var canUseDOM = function() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};
export default canUseDOM;
